/**
 * Toolband — search + filters + actions band beneath the Crown.
 * Pure layout: paper bg, line bottom hairline, padded gutter, gap. Children
 * flow left-to-right; insert a `<Toolband.Spacer />` to push the trailing
 * cluster to the right.
 *
 * Source: .agents/design/project/artboard-radical.jsx:139-176
 */

import type { ReactNode } from 'react';

interface ToolbandProps {
  children: ReactNode;
  className?: string;
}

export function Toolband({ children, className = '' }: ToolbandProps) {
  return (
    <div
      className={
        // Below `lg` (14.2, widened after iPad-portrait testing): the band
        // becomes a horizontally scrollable strip — children keep their
        // natural width and never wrap. Tablet needs it too: with the rail
        // + 340px inspector the center column (~416px) is narrower than a
        // phone viewport.
        'flex items-center gap-4 border-b border-line bg-paper px-8 py-3 ' +
        'max-lg:overflow-x-auto max-lg:[&>*]:shrink-0 max-sm:gap-2.5 max-sm:px-4 ' +
        className
      }
    >
      {children}
    </div>
  );
}

function Spacer() {
  return <div className="flex-1" />;
}

Toolband.Spacer = Spacer;
